module.exports = __webpack_public_path__ + "static/img/AJ-Brimson.7acb89e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AJ-Brimson.jpg
// module id = 9x1j
// module chunks = 0